'use strict';

const base = require('./base');
const baseDetail = require('base/product/detail');

const slider = require('../components/slider');
const secondaryQty = require('../components/updateSecondaryQuantity');

// Apply slider after loadig the images
setTimeout (function () {
    slider();
}, 500);

/**
 * update primary image based on the thumbnail selection
 */
baseDetail.thumbnailSelection = function () {
    $(document).on('click', '.thumbnail-item', function () {
        const $this = $(this),
            $indexVal = $this.attr('data-index'),
            $mainImage = $('.main-image').find(`[data-index='${$indexVal}']`);
        $this.addClass('active');
        $this.closest('.slick-slide').siblings().find('.thumbnail-item').removeClass('active');
        $mainImage.addClass('active').siblings().removeClass('active');
    });
}

baseDetail.updateQuantityValue = secondaryQty.updateQuantityValue;

baseDetail.availability = base.availability;

baseDetail.addToCart = base.addToCart;

module.exports = baseDetail;
